export default "__VITE_ASSET__B6_7hD4a__"